import Cookies from 'js-cookie'

const TokenKey = 'userToken'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

/**
 * 根据路由配置生成不用登录可访问的白名单
 * @param {Array} routerMap 常用的路由配置
 * @returns {Array}
 */
export function getWhiteList (routerMap) {
  const list = []

  function routerPath (routerMap, parentPath = '') {
    routerMap.forEach((route) => {
      const cur = route.path
      const path = cur.indexOf('/') === 0 ? cur : parentPath + '/' + cur
      if (!['/', '*', '/*', '/404'].includes(cur)) {
        list.push(path)
      }
      if (route.children && route.children.length) {
        routerPath(route.children, path)
      }
    })
  }

  routerPath(routerMap)
  return list
}
